module.exports = __webpack_public_path__ + "img/组 126(3).4ded5cc1.png";